import { AlertLevels } from 'src/models/alert-model';

export const DEFAULT_ALERT_LEVEL_TO_TIMEOUT_MAPPING: { [key: string]: number } = {
    [AlertLevels.WARNING]: -1,
    [AlertLevels.ERROR]: 10000,
    [AlertLevels.INFORMATIONAL]: -1,
    [AlertLevels.SUCCESS]: 2000
};